import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import MainInput from "./../../../component/atoms/input/mainInput";
import TextArea from "./../../../component/atoms/input/textarea";
import Radio from "./../../../component/atoms/input/radio";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import DateInput from "./../../../component/atoms/input/dateInput";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";

import Modal from "../../../component/templates/Modal";

import { toastMsg } from "../../../util/toastMsg";
import scrollToTop from "../../../util/scrollToTop";
import { errorHandler } from "../../../util/errorHandler";

import { route } from "../../../router/route";
import { hourList, minuteList } from "../../../constants/timeArr";
import SelectBoxValue from "../../../component/organisms/selectBoxValue";
import GroupApi from "../../../api/group.api";
import AlarmApi from "../../../api/alarm.api";
import moment from "moment";
import Empty from "../../../component/molecules/empty";

const OperationMessageAlarm = () => {
  const navigate = useNavigate();

  const targetList = [
    {
      title: "전체회원",
      value: "전체회원",
    },
    {
      title: "지정그룹",
      value: "지정그룹",
    },
  ];
  const [selectedTarget, setSelectedTarget] = useState("");
  const [targetListBoxOpen, setTargetListBoxOpen] = useState(false);

  const [groupList, setGroupList] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(0);
  const [groupListBoxOpen, setGroupListBoxOpen] = useState(false);

  useEffect(() => {
    if (selectedTarget === "전체회원") {
      setSelectedGroup(0);
    }
  }, [selectedTarget]);

  // ---------- 발송 시간 관련 ---------- //
  const [selectedTime, setSelectedTime] = useState("지금");

  //예약날짜
  const [sendTimeValue, setSendTimeValue] = useState("");

  const [hourBoxOpen, setHourBoxOpen] = useState(false);
  const [selectedHour, setSelectedHour] = useState("");

  const [minuteBoxOpen, setMinuteBoxOpen] = useState(false);
  const [selectedMinute, setSelectedMinute] = useState("");

  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [url, setUrl] = useState("");

  const [createModalOpen, setCreateModalOpen] = useState(false);

  const [recentlyList, setRecentlyList] = useState([]);
  const [reservationList, setReservationList] = useState([]);

  useEffect(() => {
    getNormalGroupList();
    getAlarmList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getAlarmList = async () => {
    try {
      const data01 = {
        page: 1,
        size: 6,
        sendComplete: "Active",
      };

      const response01 = (await AlarmApi.getList(data01)).data.data.content;
      setRecentlyList(response01);

      const data02 = {
        page: 1,
        size: 6,
        isNow: "Inactive",
      };
      const response02 = (await AlarmApi.getList(data02)).data.data.content;
      setReservationList(response02);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 일반 그룹 가져오기
  const getNormalGroupList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
      };

      const response = (await GroupApi.getList(data)).data.data.content;

      let groupTemp = response.map((item) => {
        return { title: item.title, value: item.id };
      });
      setGroupList(groupTemp);
    } catch (error) {
      errorHandler(error);
    }
  };

  const createAlarmFunc = async () => {
    try {
      if (selectedTarget === "") {
        return toast("발송대상을 선택해주세요.");
      }

      if (title === "") {
        return toast("알림 제목을 입력해주세요.");
      }

      if (content === "") {
        return toast("알림 내용을 입력해주세요.");
      }

      if (selectedTime === "예약") {
        if (
          selectedHour === "" ||
          selectedMinute === "" ||
          sendTimeValue === ""
        ) {
          return toast("예약 날짜를 선택해주세요.");
        }

        const selectedTime = moment(
          `${sendTimeValue} ${selectedHour}:${selectedMinute}:00`,
          "YYYY-MM-DD HH:mm:ss"
        );
        const currentTime = moment();

        if (!selectedTime.isAfter(currentTime)) {
          toast("예약 시간은 현재 시간보다 이후여야 합니다.");

          return;
        }
      }

      const data = {
        title: title,
        content: content,
        url: url,
        isNow: selectedTime === "지금" ? true : false,
        groupId: selectedGroup,
        sendDate:
          selectedTime === "지금"
            ? moment().format("YYYY-MM-DD HH:mm:ss")
            : `${sendTimeValue} ${selectedHour}:${selectedMinute}:00`,
      };

      await AlarmApi.createAlarm(data);
      setCreateModalOpen(true);
      toast(toastMsg.create);
      scrollToTop();

      setSelectedTarget("");
      setSelectedGroup(0);

      setTitle("");
      setContent("");
      setUrl("");

      setSelectedTime("지금");
      setSelectedHour("");
      setSelectedMinute("");
      setSendTimeValue("");

      await getAlarmList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>메시지 보내기</TableTitle>
          <TabWrapper>
            <Tab
              isActive={true}
              onClick={() => {
                navigate(route.operation_message_alarm);
              }}
            >
              <TabText isActive={true}>알림</TabText>
            </Tab>
            <Tab
              isActive={false}
              onClick={() => {
                navigate(route.operation_message_email);
              }}
            >
              <TabText isActive={false}>이메일</TabText>
            </Tab>
            <Tab
              isActive={false}
              onClick={() => {
                navigate(route.operation_message_sms);
              }}
            >
              <TabText isActive={false}>SMS</TabText>
            </Tab>
          </TabWrapper>

          <MessageAlarmContainer>
            {/* 발송대상 */}
            <MessageAlarmItemWrapper>
              <MessageAlarmItemTitle>발송대상</MessageAlarmItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <SelectBoxValue
                    placeholder="발송대상을 선택해주세요"
                    selectedValue={selectedTarget}
                    isOpen={targetListBoxOpen}
                    wrapperHandler={() => {
                      setTargetListBoxOpen(!targetListBoxOpen);
                    }}
                    itemList={targetList}
                    selectedValueSetterFunc={(value) => {
                      setSelectedTarget(value);
                    }}
                  />
                  {selectedTarget === "지정그룹" && (
                    <SelectBoxValue
                      placeholder="그룹을 선택해주세요"
                      selectedValue={selectedGroup}
                      isOpen={groupListBoxOpen}
                      wrapperHandler={() => {
                        setGroupListBoxOpen(!groupListBoxOpen);
                      }}
                      itemList={groupList}
                      selectedValueSetterFunc={(value) => {
                        setSelectedGroup(value);
                      }}
                    />
                  )}
                </div>
                <MessageAlarmItemContentText>
                  개별 회원에게 보내고 싶으시면 [회원관리]에서 사용자를 선택하여
                  발송하세요.
                </MessageAlarmItemContentText>
              </div>
            </MessageAlarmItemWrapper>

            {/* 알림 제목 */}
            <MessageAlarmItemWrapper>
              <MessageAlarmItemTitle>알림 제목</MessageAlarmItemTitle>
              <MainInput
                type={"text"}
                placeholder={"알림 제목을 입력해 주세요."}
                style={{
                  width: "572px",
                }}
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              />
            </MessageAlarmItemWrapper>

            {/* 알림 내용 */}
            <MessageAlarmItemWrapper>
              <MessageAlarmItemTitle>알림 내용</MessageAlarmItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}
              >
                <TextArea
                  type={"text"}
                  placeholder={"내용을 입력해주세요"}
                  value={content}
                  onChange={(e) => {
                    setContent(e.target.value);
                  }}
                  maxLength={50}
                  style={{
                    width: "572px",
                    minHeight: "107px",
                  }}
                />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <PretendardText
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      lineHeight: "18.75px",
                      color: "rgba(181, 181, 181, 0.5)",
                    }}
                  >
                    {content.length}/50
                  </PretendardText>
                </div>
              </div>
            </MessageAlarmItemWrapper>

            {/* URL 입력 */}
            <MessageAlarmItemWrapper>
              <MessageAlarmItemTitle
                style={{
                  marginTop: 0,
                }}
              >
                URL 입력
                <br />
                (선택사항)
              </MessageAlarmItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <MainInput
                  type={"text"}
                  placeholder={"URL을 입력해 주세요."}
                  style={{
                    width: "572px",
                  }}
                  value={url}
                  onChange={(e) => {
                    setUrl(e.target.value);
                  }}
                />
                <MessageAlarmItemContentText>
                  알림창을 클릭 시 이동할 페이지
                </MessageAlarmItemContentText>
              </div>
            </MessageAlarmItemWrapper>

            {/* 발송 시간 */}
            <MessageAlarmItemWrapper>
              <MessageAlarmItemTitle
                style={{
                  marginTop: 0,
                }}
              >
                발송 시간
              </MessageAlarmItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 24,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 30,
                  }}
                >
                  <Radio
                    id={""}
                    valueText={"지금"}
                    checked={selectedTime === "지금"}
                    onChange={() => {
                      setSelectedTime("지금");
                    }}
                  />
                  <Radio
                    id={""}
                    valueText={"예약"}
                    checked={selectedTime === "예약"}
                    onChange={() => {
                      setSelectedTime("예약");
                    }}
                  />
                </div>
                {selectedTime === "예약" && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: 13,
                        lineHeight: "18.75px",
                        color: "#aaa",
                        marginBottom: 10,
                      }}
                    >
                      예약한 시간에 업로드 됩니다
                    </PretendardText>
                    <DateInput
                      value={sendTimeValue}
                      onChange={(e) => {
                        setSendTimeValue(e.target.value);
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 20,
                        marginTop: 16,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <SelectBoxValue
                          isSmall={true}
                          placeholder="00"
                          selectedValue={selectedHour}
                          isOpen={hourBoxOpen}
                          wrapperHandler={() => {
                            setHourBoxOpen(!hourBoxOpen);
                          }}
                          itemList={hourList}
                          selectedValueSetterFunc={setSelectedHour}
                        />
                        <PretendardText
                          style={{
                            fontWeight: 500,
                            fontSize: 15,
                            lineHeight: "21.5px",
                            color: "#aaa",
                          }}
                        >
                          시
                        </PretendardText>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <SelectBoxValue
                          isSmall={true}
                          placeholder="00"
                          selectedValue={selectedMinute}
                          isOpen={minuteBoxOpen}
                          wrapperHandler={() => {
                            setMinuteBoxOpen(!minuteBoxOpen);
                          }}
                          itemList={minuteList}
                          selectedValueSetterFunc={setSelectedMinute}
                        />
                        <PretendardText
                          style={{
                            fontWeight: 500,
                            fontSize: 15,
                            lineHeight: "21.5px",
                            color: "#aaa",
                          }}
                        >
                          분
                        </PretendardText>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </MessageAlarmItemWrapper>
            <div
              style={{
                width: "100%",
                height: 79,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                gap: 12,
              }}
            >
              <BasicBtn
                onClick={() => {
                  createAlarmFunc();
                }}
              >
                발송하기
              </BasicBtn>
            </div>

            {/* ********** 최근 30일 발송 알림, 발송 예약 알림 ********** */}
            <div
              style={{
                height: "fit-content",
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: 26,
              }}
            >
              {/* 최근 30일 발송 알림 */}
              <AlarmBoxContainer>
                <AlarmBoxHeaderContainer>
                  <AlarmBoxHeaderWrapper>
                    <AlarmBoxHeaderTitle>
                      최근 30일 발송 알림
                    </AlarmBoxHeaderTitle>
                    <AlarmBoxHeaderMore
                      onClick={() => {
                        navigate(
                          `${route.operation_message_alarm_detail}/send`
                        );
                        scrollToTop();
                      }}
                    >
                      더보기
                    </AlarmBoxHeaderMore>
                  </AlarmBoxHeaderWrapper>
                </AlarmBoxHeaderContainer>
                <AlarmBoxContentContainer>
                  <div
                    style={{
                      width: "100%",
                      height: 354,
                    }}
                  >
                    {recentlyList.length > 0 ? (
                      recentlyList.map((item, index) => {
                        return (
                          <AlarmBoxContentWrapper key={index}>
                            <AlarmBoxContentText
                              className="truncate"
                              style={{
                                width: 254,
                              }}
                            >
                              {item.title}
                            </AlarmBoxContentText>
                            <AlarmBoxContentText>
                              {moment(item.sendDate).format("YYYY-MM-DD HH:mm")}
                            </AlarmBoxContentText>
                          </AlarmBoxContentWrapper>
                        );
                      })
                    ) : (
                      <Empty
                        style={{
                          width: "100%",
                          height: 354,
                        }}
                      />
                    )}
                  </div>
                </AlarmBoxContentContainer>
              </AlarmBoxContainer>

              {/* 발송 예약 알림 */}
              <AlarmBoxContainer>
                <AlarmBoxHeaderContainer>
                  <AlarmBoxHeaderWrapper>
                    <AlarmBoxHeaderTitle>발송 예약 알림</AlarmBoxHeaderTitle>
                    <AlarmBoxHeaderMore
                      onClick={() => {
                        navigate(
                          `${route.operation_message_alarm_detail}/reservation`
                        );
                        scrollToTop();
                      }}
                    >
                      더보기
                    </AlarmBoxHeaderMore>
                  </AlarmBoxHeaderWrapper>
                </AlarmBoxHeaderContainer>
                <AlarmBoxContentContainer>
                  <div
                    style={{
                      width: "100%",
                      height: 354,
                    }}
                  >
                    {reservationList.length > 0 ? (
                      reservationList.map((item, index) => {
                        return (
                          <AlarmBoxContentWrapper key={index}>
                            <AlarmBoxContentText
                              className="truncate"
                              style={{
                                width: 254,
                              }}
                            >
                              {item.title}
                            </AlarmBoxContentText>
                            <AlarmBoxContentText>
                              {moment(item.sendDate).format("YYYY-MM-DD HH:mm")}
                            </AlarmBoxContentText>
                          </AlarmBoxContentWrapper>
                        );
                      })
                    ) : (
                      <Empty
                        style={{
                          width: "100%",
                          height: 354,
                        }}
                      />
                    )}
                  </div>
                </AlarmBoxContentContainer>
              </AlarmBoxContainer>
            </div>
          </MessageAlarmContainer>
        </DetailPageLayout>
      </MainLayout>

      {/* 발송하기 모달창 */}
      {createModalOpen && (
        <Modal
          type="alert"
          title="발송되었습니다"
          setModalOpen={setCreateModalOpen}
          onClick={() => {
            setCreateModalOpen(false);
          }}
        />
      )}
    </>
  );
};

export default OperationMessageAlarm;

const TabWrapper = styled.div.attrs((props) => {})`
  width: fit-content;
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 30px;
`;

const Tab = styled.div.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 19px 28px;
  border-bottom: ${(props) => (props.isActive ? "2px solid #27beff" : "none")};
  cursor: pointer;
`;

const TabText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: -0.3%;
  color: ${(props) =>
    props.isActive ? "#27beff" : "rgba(181, 181, 181, 0.5)"};
`;

const MessageAlarmContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const MessageAlarmItemWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
  padding: 21px 0px;
`;

const MessageAlarmItemTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
  margin-top: 12px;
`;

const MessageAlarmItemContentText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: rgba(181, 181, 181, 0.5);
`;

const AlarmBoxContainer = styled.div.attrs((props) => {})`
  width: 509px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  background: #272829;
  box-shadow: 2px 2px 15px 0px rgba(0, 0, 0, 0.12);
  padding: 12px 0px;
  margin-top: 40px;
`;

const AlarmBoxHeaderContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: 43px;
  padding: 0px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
`;

const AlarmBoxHeaderWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AlarmBoxHeaderTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;

const AlarmBoxHeaderMore = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
  cursor: pointer;
`;

const AlarmBoxContentContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AlarmBoxContentWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  gap: 3px;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.12);
`;

const AlarmBoxContentText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.3%;
  color: #aaa;
`;
